import React, { useState, useEffect, useCallback, useRef } from 'react';

import { downloadFile, extractFileNameFromHeaders } from '../../../../util/DownloadUtil';

import { retrieveQueryAgeReport, downloadQueryAgeReport } from '../../../../services/ReportService';

import { SaveButton } from '../../../common/button/save-button/SaveButton';
import { Table } from '../../../common/table/Table';

import './QueryAge.css';

export const QueryAge = ({ facility, dates, resetFilters, context, setSpinnerText, showToaster, downloadEnabled }) => {
  const [heading, setHeading] = useState('');
  const [results, setResults] = useState([]);
  const [queryStatus, setQueryStatus] = useState({ label: 'All Queries Age', value: 'All Queries Age' });

  const queryStatusOptions = useRef([
    'All Queries Age',
    'Answered Queries Age',
    'Closed Queries Age',
    'Invalid Queries Age',
    'Open Queries Age',
    'Re-issued Queries Age',
  ]);

  const generateReport = useCallback(async () => {
    setSpinnerText('Generating Report');
    const [data, error] = await retrieveQueryAgeReport(context.username, queryStatus.value, {
      facilityExternalReference: facility.externalReference,
      dates,
    });
    if (data) {
      if (data.responseStatus === 'Success') {
        setHeading(data.heading);
        setResults(
          data.queryAgeVOS.map((vo) => {
            const { age, grandTotal, queryPerStudyVOS } = vo;

            const result = {
              queryAge: age,
            };

            queryPerStudyVOS.forEach((vo) => {
              result[vo.studyName] = vo.total;
            });

            result.grandTotal = grandTotal;

            return result;
          })
        );
      } else {
        showToaster(data);
      }
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }
    setSpinnerText(undefined);
  }, [context, setSpinnerText, showToaster, facility, dates, queryStatus.value]);

  useEffect(() => {
    generateReport();
  }, [generateReport]);

  const handleDownloadExcelClick = async () => {
    setSpinnerText('Downloading Query Age Report');
    const [data, headers, error] = await downloadQueryAgeReport(context.username, queryStatus.value, {
      facilityExternalReference: facility.externalReference,
      dates,
    });
    if (data) {
      const name = extractFileNameFromHeaders(headers);
      downloadFile(data, name);
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }
    setSpinnerText(undefined);
  };

  return (
    <section className="query-age-content">
      <div className="query-age-table">
        <h1 className="query-age-table-heading">{heading}</h1>
        <Table
          tableData={results}
          maxRowCount={7}
          hiddenColumns={[]}
          columnWidths={{ queryAge: '200px' }}
          dropdownOption={queryStatus}
          dropdownOptions={queryStatusOptions.current.map((option) => ({ label: option, value: option }))}
          onDropdownChange={setQueryStatus}
          searchEnabled
          filterEnabled
          horizontalScroll
          stickyFirstRow
        />
      </div>
      <div className="query-age-table-buttons">
        <SaveButton
          title="Reset Filters"
          onClick={resetFilters}
          color="white"
          textColor="#077187"
          border="1px solid #077187"
        />
        {downloadEnabled && (
          <SaveButton
            title="Download Excel"
            onClick={handleDownloadExcelClick}
            color="#077187"
            border="1px solid #077187"
          />
        )}
      </div>
    </section>
  );
};
